<ng-container *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.Read">
  <div class="p-grid">
    <div class="p-col-12" [ngClass]="{'p-d-flex p-jc-between breadcrembBar': showBreadcrumb}">
      <ng-container *ngIf="showBreadcrumb">
        <p-breadcrumb [model]="breadcrumbItems"></p-breadcrumb>
        <div class="p-d-flex" style="flex-direction: column;">
          <div class="p-d-flex" style="flex-direction: row;">
            <h3 class="p-mb-0 p-mt-2" pTooltip="{{tableName}}" tooltipPosition="top"
            *ngIf="!isEditHeader">{{tableName | shorten:20}}</h3>
            <input type="text" class="inline-text p-mt-2" pInputText *ngIf="isEditHeader" placeholder="Enter Workbook Name"
            [(ngModel)]="tableName" (ngModelChange)="validateName(tableName, 'Table Name')" (blur)="updateTableHeader()"  style="height:fit-content; width: 250px;" />
            <span class="btnBars p-ml-2 p-mt-2" *ngIf="!isEditHeader&&selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite" (click)="isEditHeader = true" pTooltip="Edit Workbook Name"
            tooltipPosition="top">
              <i class="pi pi-pencil"></i>
            </span>
          </div>
          <!-- <span class="btnBars p-ml-2 p-mt-2" *ngIf="isEditHeader" (click)="updateTableHeader()" pTooltip="Save Workbook Name"
          tooltipPosition="top">
            <i class="pi pi-check"></i>
          </span> -->
          <div *ngIf="validationErrors['Table Name']" class="p-error p-ml-2 p-mt-2">{{validationErrors['Table Name']}}</div>
        </div>
      </ng-container>
  
      <p-menubar [model]="menuItems" styleClass="top-menu submenu-align-right" appendTo="body">
        <ng-template pTemplate="start" style="width: 100%;">
          <ng-container *ngIf="!showBreadcrumb">
            <span *ngIf="isCustomModule && isSubModuleWidgets" class="btnBars" (click)="hideSideNavigation()" style="vertical-align: sub;" >
              <i class="pi pi-angle-double-left" *ngIf="isShowSideBtn"></i>
              <i class="pi pi-angle-double-right" *ngIf="!isShowSideBtn"></i>
            </span>
            <h3 *ngIf="!isEditHeader" style="display: inline">{{tableName}}</h3>
            <input type="text" class="inline-text" pInputText *ngIf="isEditHeader" placeholder="Enter Workbook Name"
              [(ngModel)]="tableName" (ngModelChange)="validateName(tableName, 'Table Name')" style="width: 250px;" />
            <span class="btnBars p-ml-2" *ngIf="!isEditHeader" (click)="isEditHeader = true">
              <i class="pi pi-pencil"></i>
            </span>
            <span class="btnBars p-ml-2" *ngIf="isEditHeader" (click)="updateTableHeader()">
              <i class="pi pi-check"></i>
            </span>
            <span *ngIf="validationErrors['Table Name']" class="p-error">{{validationErrors['Table Name']}}</span>
          </ng-container>
  
          <span class="p-mr-2 group-by-wrapper" *ngIf="viewType === 'ListView'">
            <button icon="pi pi-tags" pButton pRipple type="button" class="p-button-secondary p-button-text"
              (click)="groupby.toggle($event)" pTooltip="Group by" tooltipPosition="top">
            </button>
            <span *ngIf="selectedGroupByValue" class="group-by-badge"></span>
          </span>
          <app-filters [listCols]="mappedColFilter" (applyFiltersColumns)="applyFilters($event)"
          [saveFilterData]="saveFilterData" [isWorkspaceModule]="true" *ngIf="viewType === 'ListView'"></app-filters>
        </ng-template>
        <ng-template pTemplate="end">
          <div class="p-d-flex">
            <button [icon]="viewType === 'ListView' ? 'pi pi-th-large' : 'pi pi-list'" pButton pRipple type="button" class="p-button-secondary p-button-text p-mr-2"
            (click)="switchView(viewType === 'ListView' ? 'KanbanView' : 'ListView')" [pTooltip]="viewType === 'ListView' ? 'Switch to Kanban View' : 'Switch to Table View'" tooltipPosition="top"></button>
            <button icon="pi pi-refresh" pButton pRipple type="button" class="p-button-secondary p-button-text p-mr-2"
            (click)="initializeComponent();" pTooltip="Refresh" tooltipPosition="top"></button>
            <button *ngIf="!isCustomModule" icon="pi pi-arrow-left" pButton pRipple type="button" class="p-button-secondary p-button-text p-mr-2"
            (click)="navigateToBack();" pTooltip="Back" tooltipPosition="top"></button>
            <span class="p-input-icon-left" *ngIf="isHideSide">
              <i class="pi pi-search searchPosition"></i>
              <input type="text" style="float: right; margin: 2px 5px 0px 0px;" [formControl]="globalSearchValueControl"
                pInputText placeholder="Search..." />
            </span>
            <span class="btnBars p-mt-1" *ngIf="!isHideSide" pTooltip="Search" tooltipPosition="top"
            (click)="searchpanel.toggle($event)">
              <i class="pi pi-search"></i>
            </span>
          </div>
        </ng-template>
      </p-menubar>
    </div>
    <p-overlayPanel #groupby [showCloseIcon]="true" [style]="{width: '300px'}">
      <ng-template pTemplate>
        <label><strong>Group By</strong></label>
        <p-dropdown [options]="mappedColFilter" class="panelDD" [filter]="true" [(ngModel)]="selectedGroupBy"
          optionLabel="name" placeholder="Please Select Field"></p-dropdown>
        <div class="p-text-right p-mt-2">
          <p-button label="Reset" class="p-button-secondary p-mt-2 p-mr-2" (click)="resetGroup(true);groupby.hide()"
            [disabled]="!selectedGroupBy"></p-button>
          <p-button label="Apply" class="p-mt-2" (onClick)="applyGroup();groupby.hide()"
            [disabled]="!selectedGroupBy"></p-button>
        </div>
      </ng-template>
    </p-overlayPanel>
    <p-overlayPanel #searchpanel styleClass="no-padding">
      <input type="text" [formControl]="globalSearchValueControl" pInputText placeholder="Search..." />
    </p-overlayPanel>
  </div>
  <ng-container>
    <app-wb-step-bar *ngIf="statusBarData?.isStepBarEnabled && viewType === 'ListView' && !isGrouped"
      [workbookId]="workbookId"
      [columnName]="statusBarData?.columnName"
      [steps]="steps"
      (stepSelected)="onStepSelected($event)">
    </app-wb-step-bar>
    <div>
      <ng-container *ngIf="viewType === 'ListView'">
        <p-table #newtable [value]="isGrouped ? groupWorkBookRows : workbookRows" [columns]="workbookColumns"
        [tableStyle]="{'min-width': '50rem'}" [showJumpToPageInput]="true" styleClass="p-datatable-gridlines floatthead"
        [lazy]="true" (onLazyLoad)="getTableWithPagination($event)" (onPage)="pageChange($event)" [paginator]="true"
        [rows]="pageSize" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[15,25,50,100,500]"
        [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'" [scrollable]="true"
        [resizableColumns]="true" selectionMode="single" [(selection)]="selectedRow"
        (onRowSelect)="onRowSelect($event)" [(contextMenuSelection)]="selectedRow" [contextMenu]="cmenu" appFloatThead
        [forceReflow]="forceReflow" [showFloatHeader]="showFloatHeader" floatTableClassRef="floatthead"
        [floatTableRef]="newtable"
        columnResizeMode="expand"
        >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngIf="!isGrouped && hasRows" pFrozenColumn ></th>
            <th *ngIf="isGrouped" pFrozenColumn style="border-right: 1px solid var(--primary-color);" pResizableColumn>
              <div class="p-d-flex p-ai-center">
                <button type="button" pButton pRipple
                  class="p-button-text p-button-rounded p-button-plain group-expand-button" (click)="onAllGroupExpand()"
                  [pTooltip]="groupAllExpanded ? 'Collapse All': 'Expand All'"
                  [icon]="groupAllExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                </button> Group: {{selectedGroupByValue.name}}
              </div>
            </th>
            <th pFrozenColumn style="width: 100px;" *ngIf="hasRows">Action</th>
            <ng-container *ngFor="let col of columns">
              <ng-container *ngIf="col.enable">
              <th pFrozenColumn *ngIf="selectedGroupByValue?.name!=col.name" [frozen]="col.isFrozen" alignFrozen="left"
                 [frozen]="col.isFrozen" alignFrozen="left"
                pResizableColumn
                [style.min-width]="col.isFrozen ? '150px' : 'inherit'"
                class="action"
                >
                <div class="column-header">
                  <span class="column-name" [pTooltip]="col.name" tooltipPosition="top">
                    {{ col.name }}
                  </span>
                  <span class="btnBars btntoggle" (click)="curCol = col; columnMenuIndex = 1; menu.toggle($event);">
                    <i class="pi pi-chevron-circle-down"></i>
                  </span>
                </div>
  
              </th>
            </ng-container>
            </ng-container>
            <!-- <th style="width: 100px;" class="action" alignFrozen="right" pFrozenColumn [frozen]="true">
              <button icon="pi pi-plus" pButton [text]="true"
                (click)="openAddColumnDialog(); createColumnMenu.toggle($event) ">Add Column</button>
            </th> -->
          </tr>
          <p-overlayPanel #menu [styleClass]="columnMenuIndex == 1 ? 'no-padding' : ''">
            <ul *ngIf="columnMenuIndex == 1" class="table-menu">
  
              <!-- Edit Column (ReadWrite or AllAccess) -->
              <li *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite" (click)="openEditColumnDialog(curCol);"
                class="border-bottom">
                <span class="pi pi-pencil"></span> Edit
              </li>
  
              <!-- Sort (Read and above) -->
              <li *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.Read" (click)="toggleSortColumn(menu, curCol)">
                <span class="pi" [ngClass]="{
                                'pi-sort-amount-down-alt': !isDescending || selectedSortColumn?.name !== curCol?.name,
                                'pi-sort-amount-up-alt': isDescending && selectedSortColumn?.name === curCol?.name,
                                'selected-sort-icon': selectedSortColumn?.name === curCol?.name
                              }">
                </span>
                Sort
              </li>
  
              <!-- Delete Column (AllAccess only) -->
              <li *ngIf="selectedWorkbook?.permissionType === WBPermissionType.AllAccess" class="border-bottom"
                (click)="deleteWorkbookColumn(menu, curCol)">
                <span class="pi pi-trash"></span>
                Delete Column
              </li>
  
              <!-- Freeze/Unfreeze Column (Read and above) -->
              <li *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.Read"
                (click)="curCol.isFrozen = !curCol.isFrozen; updateColumnFrozen(menu, curCol)">
                <span class="pi pi-thumbtack p-mr-1" [ngClass]="{ 'selected-sort-icon': curCol?.isFrozen }">
                </span>
                <span *ngIf="curCol?.isFrozen">Unfreeze</span>
                <span *ngIf="!curCol?.isFrozen">Freeze</span>
              </li>
            </ul>
          </p-overlayPanel>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr class="parentRow" *ngIf="isGrouped">
            <td colspan="30" class="group-expand-row">
              <div class="p-d-flex p-ai-center">
                <button type="button" pButton pRipple
                  class="p-button-text p-button-rounded p-button-plain group-expand-button"
                  (click)="onGroupExpand(rowData)"
                  [icon]="rowData?.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                </button>
                <!-- <span [pTooltip]="rowData.groupValue">
                  <strong >
                    {{ rowData.groupValue ? (rowData.groupValue | shorten:27) : 'NA' }} ({{rowData.groupCount}})
                  </strong>
                </span> -->
                <ng-container [ngSwitch]="selectedGroupByValue?.formControlType">
                  <ng-container *ngSwitchCase="'DateTime'">
                    {{ selectedGroupByValue.name }} - {{ rowData.groupValue ? (rowData.groupValue | localDate:'dateTime':false) : 'NA' }} ({{rowData.groupCount}})
                  </ng-container>
                  <ng-container *ngSwitchCase="'Time'">
                      {{ selectedGroupByValue.name }} - {{ rowData.groupValue ? (rowData.groupValue | onlyTime) : 'NA' }} ({{rowData.groupCount}})
                  </ng-container>
                  <ng-container *ngSwitchCase="'UserLookup'">
                    {{ selectedGroupByValue.name }} - {{ rowData.groupValue ? (rowData.groupValue?.UserName) : 'NA' }} ({{rowData.groupCount}})
                </ng-container>
                  <ng-container *ngSwitchDefault>
                      {{ selectedGroupByValue.name }} - {{ rowData.groupValue ? (rowData.groupValue | shorten:27) : 'NA' }} ({{rowData.groupCount}})
                  </ng-container>
              </ng-container>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="isGrouped; else normalRows">
            <ng-container *ngIf="rowData?.expanded">
              <ng-container *ngFor="let workbookRow of rowData.rowList; let j = index">
                <ng-container
                  *ngTemplateOutlet="rowTemplate; context: { $implicit: workbookRow, columns: columns, rowIndex: j }">
                </ng-container>
              </ng-container>
              <tr style="margin-bottom: 5px;">
                <td colspan="30" style="padding: 0px!important;">
                  <p-paginator styleClass="child-paginator" [showCurrentPageReport]="true"
                    [currentPageReportTemplate]="('Showing {first} to {last} of {totalRecords} entries')"
                    (onPageChange)="onListPageChange($event,rowData)" [rows]="rootPageSize"
                    [totalRecords]="rowData?.groupCount">
                  </p-paginator>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-template #normalRows>
            <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: rowData, columns: columns, rowIndex: i }">
            </ng-container>
          </ng-template>
        </ng-template>
        <ng-template #rowTemplate let-workbookRow let-columns="columns" let-rowIndex="rowIndex">
          <tr [pContextMenuRow]="workbookRow" [pSelectableRow]="workbookRow">
            <td *ngIf="!isGrouped" pFrozenColumn>{{ rowIndex + 1 }}</td>
            <ng-container *ngIf="isGrouped">
              <td pFrozenColumn></td>
            </ng-container>
            <td pFrozenColumn class="dtaction">
              <span
              class="btnBars"
              [ngClass]="{'grey-icon': workbookRow?.noOfDocument== 0}"
              [pTooltip]="workbookRow?.noOfDocument ? 'Attachments (' + workbookRow?.noOfDocument + ')' : 'Add Attachment'"
              tooltipPosition="top"
              (click)="openAttachmentsModal($event, workbookRow, rowIndex + 1)">
              <!-- <i class="pi pi-paperclip" pBadge [value]="workbookRow?.noOfDocument" [badgeDisabled]="workbookRow?.noOfDocument<1" severity="success"></i> -->
              <i class="pi pi-paperclip"></i>
            </span>
            <span
              class="btnBars"
              [ngClass]="{'grey-icon': workbookRow?.noOfComments == 0}"
              pTooltip="{{
                workbookRow?.noOfUnreadComments > 0
                  ? 'Unread Comments (' + workbookRow?.noOfUnreadComments + ')'
                  : workbookRow?.noOfComments > 0
                    ? 'View Comments'
                    : 'Add Comment'
              }}"
              tooltipPosition="top"
              (click)="openCommentsModal($event, workbookRow, rowIndex + 1)">
              <i class="pi pi-envelope" pBadge [value]="workbookRow?.noOfUnreadComments" [badgeDisabled]="workbookRow?.noOfUnreadComments === 0" severity="danger"
              ></i>
            </span>
            <span class="btnBars" pTooltip="Set Reminder" tooltipPosition="top" (click)="openReminderModal($event,workbookRow, rowIndex+1)" [ngClass]="{'grey-icon': workbookRow?.noOfUpcomingReminder == 0}"
            [pTooltip]="workbookRow?.noOfUpcomingReminder ? 'Upcoming Reminder (' + workbookRow?.noOfUpcomingReminder + ')' : 'Add Reminder'">
              <!-- <i class="pi pi-bell" pBadge [value]="workbookRow?.noOfUpcomingReminder" [badgeDisabled]="workbookRow?.noOfUpcomingReminder === 0" severity="danger"></i> -->
              <i class="pi pi-bell"></i>
            </span>
            </td>
            <ng-container *ngFor="let col of columns">
              <ng-container *ngIf="col.enable">
              <td pFrozenColumn [frozen]="col?.isFrozen" *ngIf="selectedGroupByValue?.name!=col.name" alignFrozen="left">
                <ng-container [ngSwitch]="col?.formControlName">
                  <span [ngClass]="{'has-color': workbookRow?.rowData?.[col?.id]?.color}"
                    [style.background-color]="workbookRow?.rowData?.[col?.id]?.color || 'transparent'"
                    [style.color]="workbookRow?.rowData?.[col.id]?.textColor || 'inherit'">
                    <ng-container *ngSwitchCase="'DatePicker'">
                      {{ workbookRow?.rowData?.[col?.id]?.value | localDate:'MM/DD/YYYY':false}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'DateTimePicker'">
                      {{ workbookRow?.rowData?.[col?.id]?.value | localDate:'dateTime':false }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Percentage'">
                      {{ workbookRow?.rowData?.[col?.id]?.value}}<span *ngIf="workbookRow?.rowData?.[col?.id]?.value">%</span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'URL'">
                      <a href="{{workbookRow?.rowData?.[col?.id]?.value | url}}" target="_blank">{{ workbookRow?.rowData?.[col?.id]?.value
                        }}</a>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Phone'">
                      {{ workbookRow?.rowData?.[col?.id]?.value }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Currency'">
                      {{ workbookRow?.rowData?.[col?.id]?.value | currencySymbol: null : col?.currencySymbol}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Decimal'">
                      {{ workbookRow?.rowData?.[col?.id]?.value | number: '1.0-' + (col?.maxDecimalPlaces || 2) || '1.0-2'}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Multi-Line'">
                      <span pTooltip="{{workbookRow?.rowData?.[col?.id]?.value}}" tooltipPosition="top" style="white-space: pre-line;">
                        {{ workbookRow?.rowData?.[col?.id]?.value | shorten }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'RichText'">
                      <span pTooltip="{{workbookRow?.rowData?.[col?.id]?.value | removeHtmlTags}}" tooltipPosition="top">
                        {{ workbookRow?.rowData?.[col?.id]?.value | removeHtmlTags | shorten }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'EncryptedText'">
                        {{ workbookRow?.rowData?.[col?.id]?.value ? '******' : ''}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Time'">
                      {{ workbookRow?.rowData?.[col?.id]?.value | onlyTime }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'UserLookup'">
                      @if(workbookRow?.rowData?.[col?.id]?.value?.UserId){
                        <span class="truncate pointer" (click)="openTaggedUserDetails($event, workbookRow?.rowData?.[col?.id]?.value?.UserId)">
                          {{ workbookRow?.rowData?.[col?.id]?.value?.UserName }}
                          </span>
                      }
                    </ng-container>
                    <ng-container *ngSwitchCase="'FileUpload'">
                      <ng-container *ngIf="workbookRow?.rowData?.[col?.id]?.value">
                        <div class="p-d-flex">
                          <span [pTooltip]="workbookRow?.rowData?.[col?.id]?.value[0]?.fileName" tooltipPosition="top">
                            {{workbookRow?.rowData?.[col?.id]?.value[0]?.fileName | shorten:25}}
                          </span>
                          <span *ngIf="workbookRow?.rowData?.[col?.id]?.value?.length" class="p-ml-2 pointer"
                          (click)="openFiles($event,workbookRow?.rowData?.[col?.id]?.value);">
                            ({{workbookRow?.rowData?.[col?.id]?.value?.length}})
                          </span>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Picture'">
                      <ng-container *ngIf="workbookRow?.rowData?.[col?.id]?.value">
                        <div class="p-d-flex">
                          <span [pTooltip]="workbookRow?.rowData?.[col?.id]?.value[0]?.fileName" tooltipPosition="top">
                            {{workbookRow?.rowData?.[col?.id]?.value[0]?.fileName | shorten:25}}
                          </span>
                          <span *ngIf="workbookRow?.rowData?.[col?.id]?.value?.length" class="p-ml-2 pointer"
                          (click)="openPics($event,workbookRow?.rowData?.[col?.id]?.value);">
                            ({{workbookRow?.rowData?.[col?.id]?.value?.length}})
                          </span>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      {{ workbookRow?.rowData?.[col?.id]?.value }}
                    </ng-container>
                  </span>
                </ng-container>
              </td>
            </ng-container>
            </ng-container>
            <!-- <td  alignFrozen="right" pFrozenColumn [frozen]="true"></td> -->
          </tr>
        </ng-template>
  
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="workbookColumns?.length + 1">
              <div class="p-text-center">No Data Available</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  
      <ng-container *ngIf="viewType === 'KanbanView'">
        <app-workbook-kanban-view *ngIf="workbookId  && kanbanViewColumns?.length > 0 && this.selectedGroupBy?.name && isGrouped else noKanbanView"
          [workbookId]="workbookId"
          (rowSelected)="onRowSelectFromKanban($event)"
          [kanbanViewColumns]="kanbanViewColumns"
          [columnId]="this.selectedGroupBy?.id"
          [steps]="steps"
          [selectedGroupByColumn]="selectedGroupBy"
          [columnName]="this.selectedGroupBy?.name"
          (cardMoved)="onCardMoved($event)">
        </app-workbook-kanban-view>
        <ng-template #noKanbanView>
          <div class="p-text-center p-p-4">
            <p>Kanban view is only availabe when grouped by a column is applied.</p>
          </div>
        </ng-template>
      </ng-container>
      <p-contextMenu #cmenu [model]="contextMenuItems"></p-contextMenu>
   </div>
  </ng-container>
  
  <ng-container *ngIf="displayAddColumn">
    <p-dialog [header]="'Add New Column'" [(visible)]="displayAddColumn"
    (onHide)="onHideAddColumn()" [focusOnShow]="false"
    [style]="{ width: '50rem', margin:'0' }">
        <form [formGroup]="columnForm">
          <div class="p-grid p-p-1">
            <div class="p-col-12">
              <label for="name">Column Name <span style="color: red;">*</span></label>
              <input class="w-100" formControlName="name" type="text" placeholder="Column Name" pInputText
                [ngClass]="{'p-invalid': columnForm.get('name').invalid && columnForm.get('name').touched}" />
              <small *ngIf="columnForm.get('name').touched && columnForm.get('name').errors?.['required']"
                class="p-error">
                Column name is required.
              </small>
              <small *ngIf="columnForm.get('name').touched && columnForm.get('name').errors?.['maxlength']"
                class="p-error">
                Column name cannot exceed 128 characters.
              </small>
            </div>
            <div class="p-col-12">
              <label for="formControlName">Data Type <span style="color: red;">*</span></label>
              <p-dropdown [options]="dataTypes" styleClass="w-100" filter="true" optionLabel="label" [appendTo]="'body'"
                formControlName="formControlName"  placeholder="Select a Type" />
                <div *ngIf="detailsFormErrors?.formControlName" class="p-invalid">
                  <small>{{ detailsFormErrors?.formControlName }}</small>
              </div>
            </div>
            <div formArrayName="options" *ngIf="columnForm.get('formControlName')?.value?.name === 'DropDownList' || columnForm.get('formControlName')?.value?.name === 'CheckBox' || columnForm.get('formControlName')?.value?.name === 'MultipleDropDownList' || columnForm.get('formControlName')?.value?.name === 'RadioButton'"
              class="p-col-12 p-mt-1 p-mb-1">
              <div class="p-d-flex align-items-center p-jc-between">
                <h6 class="p-mt-2">Add New Options</h6>
                <div pButton (click)="addOption()" class="p-col-2 p-button-text p-button-rounded" label="" icon="pi pi-plus"></div>
              </div>
              <div cdkDropList (cdkDropListDropped)="onOptionsReorder($event, false)" class="options-list" cdkDropListData="options" [cdkDropListConnectedTo]="[]">
                <div *ngFor="let option of options.controls; let i = index" [formGroupName]="i" cdkDrag [cdkDragBoundary]="'.options-list'" class="option-item p-grid p-py-1">
                  <div class="drag-handle p-col-1" cdkDragHandle>
                    <i class="pi pi-bars"></i>
                  </div>
                  <ng-container *ngIf="(columnForm.get('formControlName')?.value?.name === 'DropDownList'|| columnForm.get('formControlName')?.value?.name === 'RadioButton')">
                    <div class="p-col-2">
                      <p-colorPicker  appendTo="body" formControlName="color" [style]="{'width':'100%'}" [ngClass]="{'p-invalid': option.get('color').invalid && option.get('color').touched}"></p-colorPicker>
                      <small *ngIf="option.get('color').invalid && option.get('color').touched" class="p-error">Color is required</small>
                    </div>
                  </ng-container>
                  <div class="p-col-7">
                    <input pInputText placeholder="Option Name" formControlName="option" class="w-100" [ngClass]="{'p-invalid': option.get('option').invalid && option.get('option').touched}">
                    <small *ngIf="option.get('option').touched && (option.get('option').errors?.['required'] || option.get('option').errors?.['whitespace'])" class="p-error">Option name is required.</small>
                    <small *ngIf="option.get('option').touched && option.get('option').errors?.['maxlength']" class="p-error">Option name cannot exceed 500 characters.</small>
                  </div>
                  <div class="p-col-2">
                    <button type="button" pButton icon="pi pi-trash" class="p-button-danger" (click)="removeOption(i)" [disabled]="i === 0"></button>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Barcode'">
              <div class="p-col-12 ">
                <label for="type">Barcode Type <span style="color: red;">*</span></label>
                <p-dropdown [options]="barcodeTypes"
                    formControlName="type" optionLabel="name" optionValue="value"
                    placeholder="Select Barcode Type" appendTo="body">
                </p-dropdown>
                <div *ngIf="detailsFormErrors?.type" class="p-invalid">
                  <small>{{ detailsFormErrors?.type }}</small>
              </div>
              </div>
            </ng-container>
            <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Currency'">
              <div class="p-col-12 ">
                <label for="type">Currency <span style="color: red;">*</span></label>
                <p-dropdown [options]="currencies" formControlName="currencyId" optionLabel="name"
                placeholder="Select Currency" [ngClass]="{'p-disabled': !displayAddColumn}" [filter]="true" appendTo="body" optionValue="id"
                >
            </p-dropdown>
                <div *ngIf="detailsFormErrors?.currencyId" class="p-invalid">
                  <small>{{ detailsFormErrors?.currencyId }}</small>
              </div>
              </div>
            </ng-container>
            <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='AutoNumber'">
              <div class="p-col-12 ">
                <label for="prefix">Prefix</label>
                <input class="w-100" formControlName="prefix" type="text" placeholder="Enter Prefix" (input)="columnForm.get('prefix').setValue($event.target.value.toUpperCase())" (keypress)="characterOnly($event)" pInputText />
                <div *ngIf="detailsFormErrors?.prefix" class="p-invalid">
                  <small>{{ detailsFormErrors?.prefix }}</small>
              </div>
              </div>
              <div class="p-col-12 ">
                <label for="startNumber">Starting No. <span style="color: red;">*</span></label>
                <p-inputNumber class="w-100" formControlName="startNumber"  placeholder="Enter Starting Sequence Number" />
                <div *ngIf="detailsFormErrors?.startNumber" class="p-invalid">
                  <small>{{ detailsFormErrors?.startNumber }}</small>
              </div>
              </div>
              <!-- <div class="p-col-12">
                <label for="endingSequenceNumber">Ending No. <span style="color: red;">*</span></label>
                <p-inputNumber class="w-100" formControlName="endingSequenceNumber"  placeholder="Enter Ending Sequence Number" />
                <div *ngIf="detailsFormErrors?.endingSequenceNumber" class="p-invalid">
                  <small>{{ detailsFormErrors?.endingSequenceNumber }}</small>
              </div>
              </div> -->
            </ng-container>
            <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Decimal'">
              <div class="p-col-12 ">
                <label for="maxDecimalPlaces">Max Decimal Place <span style="color: red;">*</span></label>
                <p-inputNumber class="w-100" formControlName="maxDecimalPlaces" (keypress)="isNumberKey($event)"  placeholder="Enter Max Decimal Places" />
                 <div *ngIf="detailsFormErrors?.maxDecimalPlaces" class="p-invalid">
                  <small>{{ detailsFormErrors?.maxDecimalPlaces }}</small>
              </div>
              </div>
            </ng-container>
            <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='EncryptedText'">
              <div class="p-col-12 ">
                <label for="name">Display Length <span style="color: red;">*</span></label>
                <p-inputNumber formControlName="displayLength" (keypress)="isNumberKey($event)" placeholder="Enter Display Length"></p-inputNumber>
                <div *ngIf="detailsFormErrors?.displayLength" class="p-invalid">
                    <small>{{ detailsFormErrors?.displayLength }}</small>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Formula'">
              <div class="p-col-12 ">
                <label for="expression">Expression <span style="color: red;">*</span></label>
                <span class="text-input-prefix with-edit-icon p-input-icon-right w-100">
                  <span class="prefix">=</span>
                  <i class="p-d-flex p-ai-center">
                      <i *ngIf="columnForm.value.expression" (click)="loadExpressionAvailableFields()" class="pi pi-pencil cursor-pointer" pTooltip="Edit Expression"
                      [tooltipOptions]="{
                        showDelay: 50,
                        hideDelay: 50,
                        positionStyle: 'fixed',
                        appendTo: 'body'
                      }"></i>
                      <i *ngIf="!columnForm.value.expression" (click)="loadExpressionAvailableFields()" class="pi pi-plus cursor-pointer" pTooltip="Add Expression"
                      [tooltipOptions]="{
                        showDelay: 50,
                        hideDelay: 50,
                        positionStyle: 'fixed',
                        appendTo: 'body'
                      }"></i>
                      <i (click)="removeExpression()" class="pi pi-trash cursor-pointer p-ml-2" pTooltip="Remove Expression"
                      [tooltipOptions]="{
                        showDelay: 50,
                        hideDelay: 50,
                        positionStyle: 'fixed',
                        appendTo: 'body'
                      }"></i>
                  </i>
                  <input pInputText type="text" formControlName="expression"  placeholder="Add Formula Expression" [readOnly]="true" />
              </span>
              <div *ngIf="detailsFormErrors?.expression" class="p-error">
                <small>{{ detailsFormErrors?.expression }}</small>
              </div>
  
              </div>
            </ng-container>
          </div>
          <div class="p-d-flex p-jc-end p-p-1">
            <p-button label="Create Column" (click)="addColumn()"></p-button>
          </div>
        </form>
    </p-dialog>
  </ng-container>
  <ng-container *ngIf="displayEditColumn">
    <p-dialog [header]="'Edit Column'" [(visible)]="displayEditColumn"
    (onHide)="onHideEditColumn()"
    [focusOnShow]="false"
    [style]="{ width: '50rem', margin:'0' }">
    <form [formGroup]="columnForm" >
      <div class="p-grid p-p-1">
        <div class="p-col-12">
          <label for="name">Column Name <span style="color: red;">*</span></label>
          <input class="w-100" formControlName="name" type="text" placeholder="Column Name" pInputText
            [ngClass]="{'p-invalid': columnForm.get('name').invalid && columnForm.get('name').touched}" />
          <small *ngIf="columnForm.get('name').touched && columnForm.get('name').errors?.['required']"
            class="p-error">
            Column name is required.
          </small>
          <small *ngIf="columnForm.get('name').touched && columnForm.get('name').errors?.['maxlength']"
            class="p-error">
            Column name cannot exceed 128 characters.
          </small>
        </div>
        <div class="p-col-12" (click)="$event.stopPropagation()">
          <label for="formControlName">Data Type<span style="color: red;">*</span></label>
          <p-dropdown [options]="dataTypes" styleClass="w-100" filter="true" optionLabel="label"
            formControlName="formControlName" placeholder="Select a Type" [appendTo]="'body'"
            >
          </p-dropdown>
          <div *ngIf="detailsFormErrors?.formControlName" class="p-invalid">
            <small>{{ detailsFormErrors?.formControlName }}</small>
        </div>
        </div>
        <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Barcode'">
          <div class="p-col-12 ">
            <label for="type">Barcode Type <span style="color: red;">*</span></label>
            <p-dropdown [options]="barcodeTypes"
                formControlName="type" optionLabel="name" optionValue="value"
                placeholder="Select Barcode Type" appendTo="body">
            </p-dropdown>
            <div *ngIf="detailsFormErrors?.type" class="p-invalid">
              <small>{{ detailsFormErrors?.type }}</small>
          </div>
          </div>
        </ng-container>
        <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Currency'">
          <div class="p-col-12 ">
            <label for="type">Currency <span style="color: red;">*</span></label>
            <p-dropdown [options]="currencies" formControlName="currencyId" optionLabel="name"
            placeholder="Select Currency" [filter]="true" appendTo="body" optionValue="id"
            >
        </p-dropdown>
            <div *ngIf="detailsFormErrors?.currencyId" class="p-invalid">
              <small>{{ detailsFormErrors?.currencyId }}</small>
          </div>
          </div>
        </ng-container>
        <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='AutoNumber'">
          <div class="p-col-12 ">
            <label for="prefix">Prefix</label>
            <input class="w-100" formControlName="prefix" type="text" (input)="columnForm.get('prefix').setValue($event.target.value.toUpperCase())" (keypress)="characterOnly($event)" placeholder="Enter Prefix" pInputText />
            <div *ngIf="detailsFormErrors?.prefix" class="p-invalid">
              <small>{{ detailsFormErrors?.prefix }}</small>
          </div>
          </div>
          <div class="p-col-12 ">
            <label for="startNumber">Starting No. <span style="color: red;">*</span></label>
            <p-inputNumber class="w-100" formControlName="startNumber" [min]="0" [ngClass]="{'p-disabled': selectedColumn?.formControlName===columnForm.get('formControlName')?.value?.name}" placeholder="Enter Starting Sequence Number" />
            <div *ngIf="detailsFormErrors?.startNumber" class="p-invalid">
              <small>{{ detailsFormErrors?.startNumber }}</small>
          </div>
          </div>
          <!-- <div class="p-col-12">
            <label for="endingSequenceNumber">Ending No. <span style="color: red;">*</span></label>
            <p-inputNumber class="w-100" formControlName="endingSequenceNumber"  placeholder="Enter Ending Sequence Number" />
            <div *ngIf="detailsFormErrors?.endingSequenceNumber" class="p-invalid">
              <small>{{ detailsFormErrors?.endingSequenceNumber }}</small>
          </div>
          </div> -->
        </ng-container>
        <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Decimal'">
          <div class="p-col-12 ">
            <label for="maxDecimalPlaces">Max Decimal Place <span style="color: red;">*</span></label>
            <p-inputNumber class="w-100" formControlName="maxDecimalPlaces" (keypress)="isNumberKey($event)"  placeholder="Enter Max Decimal Places" />
             <div *ngIf="detailsFormErrors?.maxDecimalPlaces" class="p-invalid">
              <small>{{ detailsFormErrors?.maxDecimalPlaces }}</small>
          </div>
          </div>
        </ng-container>
        <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='EncryptedText'">
          <div class="p-col-12 ">
            <label for="name">Display Length <span style="color: red;">*</span></label>
            <p-inputNumber formControlName="displayLength" (keypress)="isNumberKey($event)" placeholder="Enter Display Length"></p-inputNumber>
            <div *ngIf="detailsFormErrors?.displayLength" class="p-invalid">
                <small>{{ detailsFormErrors?.displayLength }}</small>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="columnForm.get('formControlName')?.value?.name==='Formula'">
          <div class="p-col-12 ">
            <label for="expression">Expression <span style="color: red;">*</span></label>
            <span class="text-input-prefix with-edit-icon p-input-icon-right w-100">
              <span class="prefix">=</span>
              <i class="p-d-flex p-ai-center">
                  <i *ngIf="columnForm.value.expression" (click)="loadExpressionAvailableFields()" class="pi pi-pencil cursor-pointer" pTooltip="Edit Expression"
                  [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"></i>
                  <i *ngIf="!columnForm.value.expression" (click)="loadExpressionAvailableFields()" class="pi pi-plus cursor-pointer" pTooltip="Add Expression"
                  [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"></i>
                  <i (click)="removeExpression()" class="pi pi-trash cursor-pointer p-ml-2" pTooltip="Remove Expression"
                  [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"></i>
              </i>
              <input pInputText type="text" formControlName="expression" placeholder="Add Formula Expression" [readOnly]="true" />
          </span>
          <div *ngIf="detailsFormErrors?.expression" class="p-error">
            <small>{{ detailsFormErrors?.expression }}</small>
          </div>
          </div>
        </ng-container>
        <div formArrayName="options" *ngIf="columnForm.get('formControlName')?.value?.name === 'DropDownList' || columnForm.get('formControlName')?.value?.name === 'CheckBox' || columnForm.get('formControlName')?.value?.name === 'MultipleDropDownList' || columnForm.get('formControlName')?.value?.name === 'RadioButton'"
          class="p-col-12 p-mt-1 p-mb-1">
          <div class="p-d-flex align-items-center p-jc-between">
            <h6 class="p-mt-2">Add New Options</h6>
            <div pButton (click)="addOption()" class="p-col-2 p-button-text p-button-rounded" label="" icon="pi pi-plus"></div>
          </div>
          <ng-container *ngIf="options.controls?.length">
          <div cdkDropList (cdkDropListDropped)="onOptionsReorder($event, false)" class="options-list" cdkDropListData="options" [cdkDropListConnectedTo]="[]">          
              <div *ngFor="let option of options.controls; let i = index" [formGroupName]="i" cdkDrag [cdkDragBoundary]="'.options-list'" class="option-item p-grid p-py-1">
                <div class="drag-handle p-col-1" cdkDragHandle>
                  <i class="pi pi-bars"></i>
                </div>
                <ng-container *ngIf="(columnForm.get('formControlName')?.value?.name === 'DropDownList'|| columnForm.get('formControlName')?.value?.name === 'RadioButton')">
                  <div class="p-col-2">
                    <p-colorPicker  appendTo="body" formControlName="color" [style]="{'width':'100%'}" [ngClass]="{'p-invalid': option.get('color').invalid && option.get('color').touched}"></p-colorPicker>
                    <small *ngIf="option.get('color').invalid && option.get('color').touched" class="p-error">Color is required</small>
                  </div>
                </ng-container>
                <div class="p-col-7">
                  <input pInputText placeholder="Option Name" formControlName="option" class="w-100" [ngClass]="{'p-invalid': option.get('option').invalid && option.get('option').touched}">
                  <small *ngIf="option.get('option').touched && (option.get('option').errors?.['required'] || option.get('option').errors?.['whitespace'])" class="p-error">Option name is required.</small>
                  <small *ngIf="option.get('option').touched && option.get('option').errors?.['maxlength']" class="p-error">Option name cannot exceed 500 characters.</small>
                </div>
                <div class="p-col-2">
                  <button type="button" pButton icon="pi pi-trash" class="p-button-danger" (click)="removeOption(i)"></button>
                </div>
              </div>
             
          </div>
        </ng-container>
        </div>
        <div formArrayName="updateOptions" *ngIf="(columnForm.get('formControlName')?.value?.name === 'DropDownList' || columnForm.get('formControlName')?.value?.name === 'CheckBox' || columnForm.get('formControlName')?.value?.name === 'MultipleDropDownList' || columnForm.get('formControlName')?.value?.name === 'RadioButton') && updateOptions?.length > 0" class="p-col-12">
          <h6>Update Existing Options:</h6>
          <ng-container *ngIf="updateOptions.controls?.length">
          <div cdkDropList (cdkDropListDropped)="onOptionsReorder($event, true)" class="options-list" cdkDropListData="updateOptions" [cdkDropListConnectedTo]="[]">         
              <div *ngFor="let updateOption of updateOptions.controls; let i = index" [formGroupName]="i" cdkDrag [cdkDragBoundary]="'.options-list'" class="option-item p-grid p-py-1">
                <div class="drag-handle p-col-1" cdkDragHandle>
                  <i class="pi pi-bars"></i>
                </div>
              <ng-container *ngIf="(columnForm.get('formControlName')?.value?.name === 'DropDownList'|| columnForm.get('formControlName')?.value?.name === 'RadioButton')">
                <div class="p-col-2">
                  <p-colorPicker  appendTo="body" formControlName="color" [style]="{'width':'100%'}" [ngClass]="{'p-invalid': updateOption.get('color').invalid && updateOption.get('color').touched}"></p-colorPicker>
                  <small *ngIf="updateOption.get('color').invalid && updateOption.get('color').touched" class="p-error">Color is required</small>
                </div>
              </ng-container>
              <div class="p-col-7">
                <input pInputText placeholder="Option Name" formControlName="option" class="w-100" [ngClass]="{'p-invalid': updateOption.get('option').invalid && updateOption.get('option').touched}">
                <small *ngIf="updateOption.get('option').touched && (updateOption.get('option').errors?.['required'] || updateOption.get('option').errors?.['whitespace'])" class="p-error">Option name is required.</small>
                <small *ngIf="updateOption.get('option').touched && updateOption.get('option').errors?.['maxlength']" class="p-error">Option name cannot exceed 500 characters.</small>
              </div>
              <div class="p-col-2">
                <button type="button" pButton icon="pi pi-trash" class="p-button-danger" (click)="removeExistingOption(i, updateOption)"></button>
              </div>
            </div>
          </div>
        </ng-container>
        </div>
      </div>
      <div class="p-d-flex p-jc-between p-p-1">
        <p-button label="Close" (click)="onHideEditColumn()"></p-button>
        <p-button label="Update Column" (click)="updateColumn(curCol)"></p-button>
      </div>
    </form>
  </p-dialog>
  </ng-container>
  
  <p-confirmDialog key="workbookdialog" [style]="{ width: '20vw' }" [baseZIndex]="1000000"></p-confirmDialog>
  <ng-container *ngIf="displayAddEdit">
    <app-dynamic-table-add-edit-form [displayModal]="displayAddEdit" [columnDefinitions]="workbookColumns"
      [rowNumber]="currentRowNUmber" [dynamicTableData]="dynamicTableData" [mode]="mode"
      [formHeader]="formHeader" (closeAddEditModal)="displayAddEdit = false" [dataTypesValidation]="dataTypesValidation"
      [permissionType]="selectedWorkbook?.permissionType"
      (formStatusChange)="handleFormStatusChange($event.isUpdate)">
    </app-dynamic-table-add-edit-form>
  </ng-container>
  <ng-container *ngIf="displayDynamicForm">
    <app-dynamic-workbook-form [displayModal]="displayDynamicForm" [columnDefinitions]="workbookColumns"
      (closeModalEvent)="displayDynamicForm = false; dynamicFormID=null" [dynamicTableData]="dynamicTableData"
      [formID]="dynamicFormID" (createdFormEvent)="handlecreatedFormEvent($event)">
    </app-dynamic-workbook-form>
  </ng-container>
  <!-- <p-toast position="top-right" [baseZIndex]="1000000"></p-toast> -->
  <app-predict *ngIf="displayPredict" [selectedWorkbookColumn]="workbookColumns" [display]="displayPredict"
    [selectedWorkbookId]="workbookId" (dialogClosed)="closePredict()"></app-predict>
  
    <app-add-to-list *ngIf="displayAddToList"
    [displayAddToList]="displayAddToList"
    [selectedWorkbook]="selectedWorkbook"
    (listAdded)="backListView()"
    (dialogClosed)="cancelToList()">
  </app-add-to-list>
  
  <app-saved-search-added-list *ngIf="displayAddedList"
    [displayAddedList]="displayAddedList"
    [selectedWorkbook]="selectedWorkbook"
    (tabRemoved)="backListView()"
    (dialogClosed)="cancelAddedList()">
  </app-saved-search-added-list>
  
  <!-- Workbook Import Component -->
  <app-shared-import-modal *ngIf="displayImport" [displayAddImport]="displayImport" [selectedModuleId]="workspaceModuleId"
      [selectedWorkspaceId]="workspaceId" [selectedWorkbookId]="workbookId" [disableModuleChange]="true" (dialogClosed)="hideImport()">
  </app-shared-import-modal>
  
  <!-- attachment -->
   <ng-container *ngIf="displayAttachment">
    <p-dialog [header]="attachmentHeader" [(visible)]="displayAttachment"
    (onHide)="onHideAttachmentModal(fileUpload)"
    [style]="{ width: '60rem', height: '100%', margin:'0' }"
    [position]="'right'">
        <div class="card">
          <ng-container *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite">
            <label>
              Add New Attachment
              <i class="pi pi-info-circle p-ml-1 info-icon" [pTooltip]="tooltipText" showDelay="100"
                  tooltipStyleClass="info-tooltip"></i>
            </label>
              <p-fileUpload
                  name="demo[]"
                  (uploadHandler)="onFileSelect($event, fileUpload)"
                  [multiple]="false"
                  maxFileSize="10485761"
                  customUpload = true
                  showCancelButton = false
                  [accept]="allowedExtensionsAccept"
                  #fileUpload
                  >
              </p-fileUpload>
          </ng-container>
            <p-contextMenu #documentcm [model]="documentCMItems" (onShow)="buildDocumentContextMenu()" [appendTo]="'body'"></p-contextMenu>
            <p-table [value]="documentsList" responsiveLayout="scroll"
            [paginator]="true"
            [rows]="5"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[5,10,25,50]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [totalRecords]="totalRecords"
            selectionMode="single" dataKey="id"
            [(contextMenuSelection)]="selectedDocument"
            [contextMenu]="documentcm"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th id="id">ID</th> -->
                        <th id="name">Name</th>
                        <th id="uploaded_date" pTooltip="Last Updated On" tooltipPosition="top">Updated Date</th>
                        <th id="uploaded_by">Uploaded By</th>
                        <!-- <th id="file_type">File Type</th> -->
                        <th id="file size" pTooltip="Size in KB" tooltipPosition="top">Size</th>
                        <th  style="width: 150px;" id="action">Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td class="text-center" colspan="9">No Documents found</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-document let-i="rowIndex">
                    <tr [pContextMenuRow]="document">
                        <!-- <td>{{document.idNo}}</td> -->
                        <td class="p-d-flex p-ai-center">
                          <div class="file-tableinfo">
                              <img [src]="getFileIcon(document.name)" [alt]="document.name.split('.').pop()" class="file-icon" />
                              <div>
                                  <a target="_blank" rel="noopener noreferrer" (click)="openFilePreview($event,document)"
                                  class="truncate pointer" [pTooltip]="'View: '+ document?.name" tooltipPosition="top">
                                  <span>{{ document?.name | shorten: 30 }}</span>
                                  </a>
                                  <div class="light-font"><strong>Uploaded on {{document?.createdDate | localDate}}</strong></div>
                              </div>
                          </div>
                      </td>
                        <!-- <td (click)="openFilePreview($event, document)" class="pointer">{{document?.name}}</td> -->
                        <td>{{ document?.updatedDate ? (document?.updatedDate | localDate) : (document?.createdDate | localDate) }}</td>
                        <td>{{document?.addedBy}}</td>
                        <!-- <td>{{document?.extension}}</td> -->
                        <td>{{document?.fileSizeInKB}} <span *ngIf="document?.fileSizeInKB">KB</span></td>
                        <td class="action">
                          <!-- View - Available from Read & above -->
                          <span class="btnBars p-mr-0" pTooltip="View" tooltipPosition="top"
                            (click)="openFilePreview($event, document)"
                            *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.Read">
                            <i class="pi pi-eye"></i>
                          </span>
  
                          <!-- Download - Available from Read & above -->
                          <span class="btnBars p-mr-0" pTooltip="Download" tooltipPosition="top"
                            (click)="downloadAttachmentFile(document, $event)"
                            *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.Read">
                            <i class="pi pi-download"></i>
                          </span>
  
                          <!-- Edit - Available from ReadWrite & above -->
                          <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"
                            (click)="openEditDocument(document, $event)"
                            *ngIf="selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite">
                            <i class="pi pi-pencil"></i>
                          </span>
  
                          <!-- Delete - Available only for AllAccess -->
                          <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top"
                            (click)="deleteDocument(document)"
                            *ngIf="selectedWorkbook?.permissionType === WBPermissionType.AllAccess">
                            <i class="pi pi-trash"></i>
                          </span>
                        </td>
  
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-dialog>
   </ng-container>
  
  <ng-container *ngIf="displayEditDocument">
    <p-dialog header="Edit Document" [(visible)]="displayEditDocument" [modal]="true" [closable]="false"
    [style]="{width: '60vw'}" (onHide)="onHideEditDocument()">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Document Name</label>
                <input  type="text" pInputText [(ngModel)]="tempDocumentName" (ngModelChange)="validateName(tempDocumentName,'Document Name')">
                <span *ngIf="validationErrors['Document Name']" class="p-error p-mt-3">{{validationErrors['Document Name']}}</span>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayEditDocument=false" label="Cancel"
            class="p-button-secondary"></button>
        <button  type="submit" pButton label="Save" (click)="editDocumentName(tempDocumentName)"></button>
    </p-footer>
  </p-dialog>
  </ng-container>
  
  <app-shared-file-opener *ngIf="displayFilePreview" [modalDisplay]="displayFilePreview" [modalFile]="currentFile" [directLink]="true" (closeFilePreview)="closeFilePreview()"></app-shared-file-opener>
  
  <ng-container *ngIf="displayComments">
    <p-dialog [header]="'Comments: Row ' + selectedWorkbookRow?.rowIndex"  [(visible)]="displayComments" [style]="{ width: '60rem', height: '100%', margin:'0' }" [position]="'right'" (onHide)="onHideCommentsModal()" [focusOnShow]="false">
  <app-workbook-comment [workbookId] = "workbookId" [rowNumber]="selectedWorkbookRow.RowNumber" [updateReadStatus]="updateReadStatus" [permissionType]="selectedWorkbook?.permissionType">
  </app-workbook-comment>
  </p-dialog>
  </ng-container>
  
  <ng-container *ngIf="displayReminder">
     <app-workbook-reminder [displayReminder]="displayReminder" [workbookReminderProps]="workbookReminderProps" (onHide)="onHideReminderModal()"   (reminderUpdateStatus)="reminderUpdateStatus($event.isUpdate)"
     ></app-workbook-reminder>
  </ng-container>
  
  <app-workbook-dynamic-charts *ngIf="displayDynamicCharts" [displayDialog]="displayDynamicCharts"
      [workbookId]="selectedWorkbook.intId"
      [allListColumns]="allListColumns"
      (onDialogClosed)="closeDynamicCharts()">
  </app-workbook-dynamic-charts>
  
  <app-shared-export-modal-new moduleName="Workbook" [objectId]="workspaceModuleId" [workbookId]="workbookId" [channelId]="1"
      [allListColumns]="allListColumns" [display]="displayExport" [workbookName]="tableName" [workspaceName]="workspaceName" [isActive]="true" (onExportComplete)="onExportCompleted()"
      (cancelClicked)="onExportCompleted()">
  </app-shared-export-modal-new>
  
  <app-shared-column-setting-modal *ngIf="displayColumnSettings" [displayColumnSettings]="displayColumnSettings" moduleName="Workbook" [disabledLabelNames]="disabledLabelNames"
      [settingsObj]="columnSettingsN" [selectedView]="selectedView" [workbookId] = "workbookId"
      (savedColumnSettings)="savedColumnSettings()" (cancelColumnSettings)="cancelColumnSettings()" [workbookColumns]="workbookColumns" [selectedWorkbookColumn] = "statusBarData?.columnId">
  </app-shared-column-setting-modal>
  
  <app-add-fields-expression-dialog
      *ngIf="displayAddExpression"
      [displayAddExpression]="displayAddExpression"
      [expressionText]="expressionText"
      [availableFieldsForExpression]="availableFieldsForExpression"
      (expressionSaved)="saveExpression($event)"
      (dialogClosed)="expressionDialogClose()"
  >
  </app-add-fields-expression-dialog>
  <ng-container *ngIf="displayUserDetails&&selectedUser">
    <user-details-modal [display]="displayUserDetails" [selectedUserId]="selectedUser"
    (close)="closeTaggedUserDetails()"></user-details-modal>
  </ng-container>
  
  <!-- files and pics -->
  <app-file-viewer
      [displayDialog]="displayFileDialog"
      [displayType]="displayType"
      [displayItems]="displayItems"
      (displayDialogChange)="onDisplayDialogChange($event)">
  </app-file-viewer>
  
  <app-workbook-row-to-module-object *ngIf="displayConvertToDifferentModule" [displayDialog]="displayConvertToDifferentModule" [selectedModuleId]="accountmoduleId"  [selectedWorkspaceId]="workspaceId" [selectedWorkbookId]="workbookId" (dialogClosed)="onHideconvertToOtherModuleObject($event)" [selectedRow]="selectedRow" [isCopyMoveWBRow]="isCopyMoveWBRow" [isCopyWBRow]="isCopyWBRow" [isMoveWBRow]="isMoveWBRow" [isCreateDuplicateRow]="isCreateDuplicateRow"/>
  
  <ng-container *ngIf="displayBulkDelete">
  <p-dialog header="Select Rows for Bulk Deletion" [(visible)]="displayBulkDelete" [modal]="true" (onHide)="closeBulkDelete()"  [style]="{width: '70vw'}">
    <app-shared-workbook-listing
      *ngIf="selectedWorkbook?.intId"
      #sharedWorkbookListing
      [workbookIntId]="selectedWorkbook?.intId"
      [multiSelect]="true"
      [showSelection]="true"
      >
    </app-shared-workbook-listing>
  
    <p-footer>
      <button type="button" pButton label="Cancel" class="p-button-secondary" (click)="closeBulkDelete()"></button>
      <button type="button" pButton label="Reset" class="p-button-secondary" (click)="resetSelection()"></button>
      <button type="button" pButton label="Delete" (click)="saveBulkDelete()"></button>
    </p-footer>
   </p-dialog>
  </ng-container>
  </ng-container>
  <!-- No Access Message -->
  <div *ngIf="selectedWorkbook?.permissionType && selectedWorkbook?.permissionType < WBPermissionType.Read" class="p-d-flex p-jc-center p-ai-center p-p-4">
    <div class="p-text-center">
      <i class="pi pi-lock p-mb-3" style="font-size: 3rem;"></i>
      <h2 class="p-mb-2">Access Denied</h2>
      <p>You don't have permission to view this workbook. Please contact workbook owner for access.</p>
    </div>
  </div>